import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

export default function NotFoundPage() {
  const { language } = useLanguage();
  return <section className="mx-auto max-w-3xl px-6 py-24">
    <p className="text-sm font-semibold text-goszakup-700">404</p>
    <h1 className="mt-3 text-3xl font-bold text-slate-900">{language === 'kk' ? 'Бет табылмады' : 'Страница не найдена'}</h1>
    <p className="mt-4 text-slate-600">{language === 'kk' ? 'Мекенжайды тексеріңіз немесе басты бетке өтіңіз.' : 'Проверьте адрес или перейдите на главную страницу.'}</p>
    <Link to="/" className="mt-6 inline-flex min-h-[44px] items-center font-semibold text-goszakup-700 underline">{language === 'kk' ? 'Басты бетке' : 'На главную'}</Link>
  </section>;
}
